import { render, staticRenderFns } from "./LoginTabs.vue?vue&type=template&id=18a8f997&"
import script from "./LoginTabs.vue?vue&type=script&lang=js&"
export * from "./LoginTabs.vue?vue&type=script&lang=js&"
import style0 from "./LoginTabs.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports